import { Skeleton, Stack } from '@mui/material';

export const ToniAILoadingIndicator = () => {
  return (
    <Stack direction="row" gap="0.125rem">
      {[1, 2, 3].map((index) => (
        <Skeleton
          variant="circular"
          width="8px"
          height="8px"
          style={{ background: 'var(--ui05)' }}
          key={index}
        />
      ))}
    </Stack>
  );
};
